// extracted by mini-css-extract-plugin
export default {"wrapper":"MarketsToolbar_wrapper__FFtt2","active":"MarketsToolbar_active__7-+yp"};